import { ofType } from 'redux-observable-es6-compat';
import { from, Observable } from 'rxjs';
import { filter, map, mergeMap, pluck, tap } from 'rxjs/operators';

import { ASetEvent, ASetTempo, TFamily, TPlaylist, TRemote } from '../actions';
import { EventFamily, LibraryTopic, Media, Playlist, Tempo } from '../entities';
import { TPlaylistMw } from '../actions/playlists-mw.action';

const temposListeners = [
  TFamily.FETCH_FAMILIES,
  TPlaylist.FETCH_TEMPOS,
  TRemote.SET_REMOTE,
];


const pathAndTimeoutmap = new Map<string, number>();
let fetchPlaylistsEpicTimeout = 0;

export const fetchPlaylistsEpic = (action$, _ , { restApi }) =>
  action$.pipe(
    filter(({ type }) => temposListeners.includes(type)),
    filter(() => new Date().getTime() - fetchPlaylistsEpicTimeout > 2000),
    tap ( () => fetchPlaylistsEpicTimeout = new Date().getTime()),
    mergeMap(() => restApi.get(`/events`, 15000)),
    mergeMap<Playlist[], Observable<Playlist>>((events) => from(events)),
    filter(({ id }) => !pathAndTimeoutmap.has(`/media/event/${id}`) ||
      new Date().getTime() - pathAndTimeoutmap.get(`/media/event/${id}`) > 2000),
    tap ( ({ id }) => pathAndTimeoutmap.set(`/media/event/${id}`, new Date().getTime())),
    mergeMap<Playlist, Observable<[Media, string]>>(({ id, ...event }) => restApi.get(`/media/event/${id}`).pipe(
      map<Playlist, Media>(assoMediaEvent => ({ ...event, assoMediaEvent, id }))
    )),
    map(ASetEvent),
  );

let fetchFamiliesEpicTimeout = 0;

export const fetchTemposEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => temposListeners.includes(type)),
    filter(() => new Date().getTime() - fetchFamiliesEpicTimeout > 2000),
    tap ( () => fetchFamiliesEpicTimeout = new Date().getTime()),
    mergeMap(() => restApi.get(`/tempo`, 15000)),
    mergeMap<Tempo[], Observable<Tempo>>((tempos) => from(tempos)),
    filter(({ id }) => !pathAndTimeoutmap.has(`/media/tempo/${id}`) ||
      new Date().getTime() - pathAndTimeoutmap.get(`/media/tempo/${id}`) > 2000),
    tap ( ({ id }) => pathAndTimeoutmap.set(`/media/tempo/${id}`, new Date().getTime())),
    mergeMap<Tempo, Observable<[Media, string]>>(({ id, ...tempo }) => restApi.get(`/media/tempo/${id}`).pipe(
      map<Tempo, Media>(assoMediaEvent => ({ ...tempo, assoMediaEvent, id }))
    )),
    map(ASetTempo),
  );



export const fetchPlaylistFromLibraryEpic = (actions$, state$, { restApi }) => actions$.pipe(
  ofType(TPlaylistMw.SET_PLAYLIST_MW),
  mergeMap(({ payload }: { payload: EventFamily[] }) => from(payload)),
  filter<EventFamily>(({ libraryTopicType }) => libraryTopicType === LibraryTopic.EVENT),
  filter(({ id }) => !pathAndTimeoutmap.has(`/event/${id}`) || new Date().getTime() - pathAndTimeoutmap.get(`/event/${id}`) > 2000),
  tap ( ({ id }) => pathAndTimeoutmap.set(`/event/${id}`, new Date().getTime())),
  mergeMap(({ id }) => restApi.get(`/event/${id}`)),
  mergeMap<Playlist, Observable<[Media, string]>>(({ id, ...event }) => restApi.get(`/media/event/${id}`).pipe(
    map<Playlist, Media>(assoMediaEvent => ({ ...event, assoMediaEvent, id }))
  )),
  map(ASetEvent),
);

export const fetchPlaylistFromFamiliesEpic = (actions$, state$, { restApi }) => actions$.pipe(
  ofType(TPlaylistMw.SET_PLAYLIST_MW),
  mergeMap(({ payload }: { payload: EventFamily[] }) => from(payload)),
  filter<EventFamily>(({ libraryTopicType }) => libraryTopicType === LibraryTopic.EVENTFAMILY),
  filter(({ id }) => !pathAndTimeoutmap.has(`/eventfamily/${id}`)
    || new Date().getTime() - pathAndTimeoutmap.get(`/eventfamily/${id}`) > 2000),
  tap( ({ id }) => pathAndTimeoutmap.set(`/eventfamily/${id}`, new Date().getTime())),
  mergeMap(({ id }) => restApi.get(`/eventfamily/${id}`)),
  pluck('events'),
  mergeMap<Playlist[], Observable<Playlist>>((events) => from(events)),
  mergeMap<Playlist, Observable<[Media, string]>>(({ id, ...event }) => restApi.get(`/media/event/${id}`).pipe(
    map<Playlist, Media>(assoMediaEvent => ({ ...event, assoMediaEvent, id }))
  )),
  map(ASetEvent),
);
